import { getInputMask, toNormalMask } from '../utils/nodeInputMask'
import { bubble } from '../utils/bubble'
import CatalogFilter from '../catalogFilter'
import { getCfg } from '../utils/getCfg'

export const els = {
  form: "[data-js-form]",
  errorsList: "[data-js-form-errors]",
  formInput: "[data-js-input-required]",
  formInputMsgBlock: "[data-js-input-msg-block]",
  formInputMsg: "[data-js-input-msg]",
  formInputPlaceholder: "[data-js-input-placeholder]",
  formBlock: ".form__block",
  formRow: ".form__row",
  formCol: ".form__col",
  customCfg: "[data-form-cfg]",
  inputs: "input, select, textarea",
  submitAppend: "[data-js-form-append-params]",
  skipConfirmation: "[data-js-form-skip-confirmation]",
}

export default class FormValidation {
  form = '[data-form]'
  formInput = '[data-input-required]'
  formInputError = '[data-input-error]'
  formInputPlaceholder = '[data-input-placeholder]'
  termsInput = '[data-input-required-terms]'

  emptyMsg = {
    default: {
      ru: 'Заполните поле!',
      en: 'Fill in the field'
    },
    file: {
      ru: 'Укажите файл',
      en: 'Specify a file'
    },
  }

  invalidMsg = {
    default: {
      ru: 'Неверный формат',
      en: 'Wrong format'
    },
    password: {
      ru: 'Не совпадают',
      en: 'Do not match'
    },
    captcha: {
      ru: 'Не заполнено',
      en: 'Fill in the field'
    },
    invalidRadio: {
      ru: 'Выберите хотя бы одну опцию',
      en: 'Choose at least one option'
    }
  }

  constructor () {
    this.bindEvents()
  }

  formTermsInput () {
    return this.termsInput.substring(1, this.termsInput.length - 1)
  }

  formInputSelector () {
    return this.formInput.substring(1, this.formInput.length - 1)
  }

  formInputPlaceholderSelector () {
    return this.formInputPlaceholder.substring(1, this.formInputPlaceholder.length - 1)
  }

  bindEvents () {
    const self = this

    $(document).on('submit', this.form, function () {

      if (!$(this).attr('data-form-no-ajax') === 'true') {
        self.validate($(this))
        return false
      }

      self.validate($(this))
      return false

    })

    $(document).on('focus click', this.formInput, function () {
      $(this).attr('placeholder', $(this).attr(self.formInputPlaceholderSelector()))
    })

    $(document).on('blur', this.form + ' ' + this.formInput, function () {
      self.validate($(this).closest('form'), $(this))
    })

    $(document).on('change', this.termsInput, function () {
      // self.termsToggle($(this));
    })
  }

  validate ($form, inputs) {
    const cfg = getCfg($form[0], els.customCfg, {})
    const captcha = $form.find('#g-recaptcha-response');
    const self = this
    const $inputs = inputs || $form.find(this.formInput)
    const valid = []
    const invalidInputNodes = []

    $inputs.each(function () {
      const type = $(this).attr(self.formInputSelector()) || 'text'
      const val = $(this).val()
      const formBlock = $(this).closest('.form-block')
      const errorMsg = $(this).attr('data-input-error') || null
      let isValid = false;

      $(this).removeClass('invalid')
      formBlock.find('.form-block__error').empty()

      if (!val.length) {
        valid.push(self.invalid($(this), errorMsg))
        invalidInputNodes.push($(this))
      } else {

        switch (type) {
          case 'email':
            isValid = self.validateEmail(val);
            if (isValid) {
              valid.push(self.valid($(this)))
            } else {
              valid.push(self.invalid($(this), self.invalidMsg.default[App.lang]))
              invalidInputNodes.push($(this))
            }

            break
          case 'phone':
            isValid = self.validatePhone(val, this)
            if (isValid) {
              valid.push(self.valid($(this)))
            } else {
              valid.push(self.invalid($(this), self.invalidMsg.default[App.lang]))
              invalidInputNodes.push($(this))
            }

            break
          case 'checkbox':
            isValid = self.validateCheckbox($(this))
            if (isValid) {
              valid.push(self.valid($(this)))
            } else {
              valid.push(self.invalid($(this)))
              invalidInputNodes.push($(this))
            }

            break
          case 'radio':
            isValid = self.validateRadio($(this))
            if (isValid) {
              valid.push(self.valid($(this)))
            } else {
              valid.push(self.invalid($(this), self.invalidMsg.invalidRadio[App.lang]))
              invalidInputNodes.push($(this))
            }

            break
          case 'password':
            isValid = self.validatePassword($(this))
            if (isValid) {
              valid.push(self.valid($(this)))
            } else {
              valid.push(self.invalid($(this), self.invalidMsg.password))
              invalidInputNodes.push($(this))
            }

            break
          default:
            isValid = self.validateText($(this))
            if (isValid) {
              valid.push(self.valid($(this)))
            } else {
              valid.push(self.invalid($(this), self.invalidMsg.default[App.lang]))
              invalidInputNodes.push($(this))
            }

            break
        }

        if(captcha.length > 0) {
          isValid = self.validateText(captcha)
          if (isValid) {
            valid.push(self.valid(captcha.closest('.recaptcha')));
          } else {
            valid.push(self.invalid(captcha.closest('.recaptcha'), self.invalidMsg.captcha[App.lang]));
            invalidInputNodes.push(captcha.closest('.recaptcha'))
          }
        }
      }
    })

    if (!inputs) {
      let validCount = 0

      valid.forEach(function (item) {
        item ? validCount++ : null
      })

      if (valid.length === validCount) {

        if ($form.attr('data-form-no-ajax') === 'false') {
          $form.attr('data-form-no-ajax', 'true')
          $form.submit()
          return
        }

        bubble($form[0], 'form::valid')
      } else {
        bubble(document, CatalogFilter.bubbles.expandCollapses)
        if(!!cfg?.isScrollToFirstInvalidInput) {
          setTimeout(() => {
            if(!!invalidInputNodes.length) {
              try {
                invalidInputNodes[0][0].scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                  inline: "start"
                })
              } catch (e) {
                console.error(`[FormValidation]: could not scroll to first invalid input because of error: ${e}`)
              }
            }
          }, 400);
        }
      }

      return valid.length === validCount
    }
  }

  validateEmail (email) {
    const re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
  }

  validatePhone (phoneValue, phoneNode) {
    const normalMask = toNormalMask(getInputMask(phoneNode))
    const re = new RegExp(normalMask)
    //const re = /(([+][(]?[0-9]{1,3}[)]?)|([(]?[0-9]{4}[)]?))\s*[)]?[-\s]?[(]?[0-9]{1,3}[)]?([-\s]?[0-9]{3})([-\s]?[0-9]{3,4})/g
    return re.test(phoneValue)
  }

  validateCheckbox ($elem) {
    return $elem.prop('checked')
  }

  validateRadio($elem) {
    const name = $elem.attr("name");
    return (name) ? [ ...document.querySelectorAll(`[name="${name}"]`) ].some(item => item.checked) : false;
  }

  validatePassword ($elem) {
    const $elems = $elem.closest('form').find('[data-input-required="password"]')
    const passValues = []

    $elems.each(function () {
      passValues.push($(this).val())
    })

    return passValues[0] === passValues[1]
  }

  validateText ($elem) {
    return !!($elem.val().length)
  }

  invalid (elem, errorMessage) {
    let message = errorMessage || this.emptyMsg.default[App.lang]

    elem.removeClass('valid').addClass('invalid')
    elem.closest('.form-group').removeClass('valid').addClass('invalid')
    const formBlock = elem.closest('.form-block')
    formBlock.removeClass('valid').addClass('invalid')
    const errorBlock = formBlock[0]?.querySelector(this.formInputError)
    if(errorBlock) errorBlock.textContent = message

    return false
  }

  valid (elem) {
    elem.removeClass('invalid').addClass('valid')
    elem.closest('.form-group').removeClass('invalid').addClass('valid')
    const formBlock = elem.closest('.form-block')
    formBlock.removeClass('invalid').addClass('valid')
    const errorBlock = formBlock[0]?.querySelector(this.formInputError)
    if(errorBlock) errorBlock.textContent = ""

    return true
  }
}
